export default __webpack_public_path__ + "e32a44a59372022d6fdbeece06a3a18c.jpg";